if (!customElements.get('product-form')) {
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector('form');

				this.form.querySelector('[name=id]').disabled = false;
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

				this.cart         = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
				this.submitButton = this.querySelector('[type="submit"]');

				if (document.querySelector('cart-drawer')) {
					this.submitButton.setAttribute('aria-haspopup', 'dialog');
				}

				this.hideErrors = this.dataset.hideErrors === 'true';
			}

			onSubmitHandler(event) {
				event.preventDefault();

				if (this.submitButton.getAttribute('aria-disabled') === 'true') {
					return;
				}

				this.handleErrorMessage();

				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.classList.add('loading');
				this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

				const formData = new FormData(this.form);

				const sectionId          = this.dataset.sectionId;
				const giftwrapIdInput    = this.querySelector('#giftwrap_id-' + sectionId);
				const giftwrapCheckbox   = this.querySelector('#giftwrap_checkbox-' + sectionId);
				const giftwrapMessage    = this.querySelector('#giftwrap_message-' + sectionId);
				const productTitleInput  = this.querySelector('#product_title-' + sectionId);
				const variantAccessInput = document.getElementById('productVariantAccess-' + sectionId);
				const addGiftwrap        = !!(giftwrapCheckbox && giftwrapCheckbox.checked);

				if (this.cart) {
					formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
					formData.append('sections_url', window.location.pathname);

					this.cart.setActiveElement(document.activeElement);
				}

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								errors: response.errors || response.description,
								message: response.message,
							});

							this.handleErrorMessage(response.description);

							const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

							if (!soldOutMessage) {
								return;
							}

							this.submitButton.setAttribute('aria-disabled', true);
							this.submitButton.querySelector('span').classList.add('hidden');

							soldOutMessage.classList.remove('hidden');

							this.error = true;

							return;
						}

						if (!addGiftwrap) {
							return response;
						}

						// Gift wrap is a separate line item, added with its own request so the
						// main /cart/add.js call above can carry the form's full FormData
						// (recipient fields, selling plans, etc.) instead of a hand-built body.
						const giftwrapBody = {
							id:         giftwrapIdInput.value,
							quantity:   parseInt(formData.get('quantity')) || 1,
							properties: {
								Item:            productTitleInput  ? productTitleInput.value  : '',
								'Buying Option': variantAccessInput ? variantAccessInput.value : '',
								Message:         giftwrapMessage    ? giftwrapMessage.value    : '',
							},
						};

						if (this.cart) {
							giftwrapBody.sections     = this.cart.getSectionsToRender().map((section) => section.id);
							giftwrapBody.sections_url = window.location.pathname;
						}

						return fetch('/cart/add.js', {
							method:  'POST',
							headers: new Headers({ 'Content-Type': 'application/json' }),
							body:    JSON.stringify(giftwrapBody),
						})
							.then((giftwrapResponse) => giftwrapResponse.json())
							.then((giftwrapResponse) => {
								if (giftwrapResponse.status) {
									console.error(giftwrapResponse.description || giftwrapResponse.message);

									return response;
								}

								return giftwrapResponse;
							});
					})
					.then((response) => {
						if (!response) {
							return;
						}

						if (!this.cart) {
							window.location = window.routes.cart_url;

							return;
						}

						if (!this.error) {
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source:           'product-form',
								productVariantId: formData.get('id'),
								cartData:         response
							});
						}

						this.error = false;

						const quickAddModal = this.closest('quick-add-modal');

						if (quickAddModal) {
							document.body.addEventListener(
								'modalClosed',
								() => {
								setTimeout(() => {
									this.cart.renderContents(response);
								});
								},
								{ once: true }
							);

							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove('loading');

						if (this.cart && this.cart.classList.contains('is-empty')) {
							this.cart.classList.remove('is-empty');
						}

						if (!this.error) {
							this.submitButton.removeAttribute('aria-disabled');
						}

						this.querySelector('.loading-overlay__spinner').classList.add('hidden');

						if (giftwrapCheckbox) {
							giftwrapCheckbox.checked = false;
						}

						if (giftwrapMessage) {
							giftwrapMessage.style.display = 'none';
						}
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) {
					return;
				}

				this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

				if (!this.errorMessageWrapper) {
					return;
				}

				this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}

// if (!customElements.get('product-form')) {
// 	customElements.define(
// 		'product-form',
// 		class ProductForm extends HTMLElement {
// 			constructor() {
// 				super();

// 				this.form = this.querySelector('form');
// 				this.form.querySelector('[name=id]').disabled = false;
// 				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
// 				this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
// 				this.submitButton = this.querySelector('[type="submit"]');

// 				if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

// 				this.hideErrors = this.dataset.hideErrors === 'true';
// 			}

// 			onSubmitHandler(evt) {
// 				evt.preventDefault();
// 				if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

// 				this.handleErrorMessage();

// 				this.submitButton.setAttribute('aria-disabled', true);
// 				this.submitButton.classList.add('loading');
// 				this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

// 				const config = fetchConfig('javascript');
// 				config.headers['X-Requested-With'] = 'XMLHttpRequest';
// 				delete config.headers['Content-Type'];

// 				const formData = new FormData(this.form);
// 				if (this.cart) {
// 					formData.append(
// 						'sections',
// 						this.cart.getSectionsToRender().map((section) => section.id)
// 					);
// 					formData.append('sections_url', window.location.pathname);
// 					this.cart.setActiveElement(document.activeElement);
// 				}
// 				config.body = formData;

// 				fetch(`${routes.cart_add_url}`, config)
// 				.then((response) => response.json())
// 				.then((response) => {
// 					if (response.status) {
// 						publish(PUB_SUB_EVENTS.cartError, {
// 							source: 'product-form',
// 							productVariantId: formData.get('id'),
// 							errors: response.errors || response.description,
// 							message: response.message,
// 					});
// 					this.handleErrorMessage(response.description);

// 					const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
// 					if (!soldOutMessage) return;
// 						this.submitButton.setAttribute('aria-disabled', true);
// 						this.submitButton.querySelector('span').classList.add('hidden');
// 						soldOutMessage.classList.remove('hidden');
// 						this.error = true;
// 						return;
// 					} else if (!this.cart) {
// 						window.location = window.routes.cart_url;
// 						return;
// 					}

// 					if (!this.error)
// 						publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
// 					this.error = false;
// 					const quickAddModal = this.closest('quick-add-modal');
// 					if (quickAddModal) {
// 						document.body.addEventListener(
// 							'modalClosed',
// 							() => {
// 							setTimeout(() => {
// 								this.cart.renderContents(response);
// 							});
// 							},
// 							{ once: true }
// 						);
// 						quickAddModal.hide(true);
// 					} else {
// 						this.cart.renderContents(response);
// 					}
// 				})
// 				.catch((e) => {
// 					console.error(e);
// 				})
// 				.finally(() => {
// 					this.submitButton.classList.remove('loading');
// 					if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
// 					if (!this.error) this.submitButton.removeAttribute('aria-disabled');
// 					this.querySelector('.loading-overlay__spinner').classList.add('hidden');
// 				});
// 			}

// 			handleErrorMessage(errorMessage = false) {
// 				if (this.hideErrors) return;

// 				this.errorMessageWrapper =
// 				this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
// 				if (!this.errorMessageWrapper) return;
// 					this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

// 				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

// 				if (errorMessage) {
// 					this.errorMessage.textContent = errorMessage;
// 				}
// 			}
// 		}
// 	);
// }